// import React, { useState } from 'react';
// import {
//   Box,
//   Grid,
//   Button,
//   CardContent,
//   Divider,
//   TextField,
//   Typography,
//   Stack,
//   Avatar
// } from '@mui/material';
// import { LoadingButton } from '@mui/lab';
// import Alert from '@mui/material/Alert';
// import { api } from '../../../Api';
// import { Encryption } from 'src/functions/function';
// import { useTranslation } from 'react-i18next';

// export default function EditUserModal({ handleClose, user, refreshAdmin }) {
//   const { t } = useTranslation();
//   const [loading, setloading] = useState(false);
//   const [alert, setalert] = useState({ visible: false, message: '' });

//   function SaveProfile() {
//     const token = localStorage.getItem('token');
//     const myHeaders = new Headers();
//     myHeaders.append('Authorization', `Bearer ${token}`);

//     const formdata = new FormData();

//     formdata.append('name', Encryption(firstName, process.env.REACT_APP_SECRET_KEY));
//     formdata.append('id', user?.id);
//     formdata.append('email', Encryption(email, process.env.REACT_APP_SECRET_KEY));
//     formdata.append('contact_no', Encryption(contact, process.env.REACT_APP_SECRET_KEY));

//     if (file) {
//       formdata.append('avatar', file.file);
//     }

//     const requestOptions = {
//       method: 'POST',
//       headers: myHeaders,
//       body: formdata,
//       redirect: 'follow'
//     };

//     setloading(true);

//     fetch(api.updateProfile, requestOptions)
//       .then((response) => response.text())
//       .then((result) => {
//         const response = JSON.parse(result);
//         if (response.success === true) {
//           refreshAdmin();
//         } else {
//           setalert({ visible: true, message: Object.values(response?.message)[0][0] });
//         }
//       })
//       .catch((error) => console.log('error', error))
//       .finally(() => setloading(false));
//   }

//   const [file, setfile] = useState({ image: user.avatar, file: '' });
//   const [firstName, setfirstName] = useState(user.name);
//   const [email, setemail] = useState(user.email);
//   const [contact, setcontact] = useState(user.contact_no);

//   const [objAfter, setobjAfter] = useState({
//     firstName: user?.name,
//     email: user?.email,
//     contact: user?.contact_no,
//     file: false
//   });

//   return (
//     <Box p={1} mt={2}>
//       <Typography variant="h4" style={{ fontWeight: 'bold', textAlign: 'center' }}>
//         {t('EditProfile.name')}
//       </Typography>

//       <CardContent>
//         <Stack
//           mb={2}
//           direction={{ xs: 'column' }}
//           style={{ display: 'flex', flexDirection: 'row' }}
//           className="image_center"
//         >
//           <Box
//             style={{
//               alignItems: 'center',
//               display: 'flex',
//               flexDirection: 'column'
//             }}
//           >
//             {file && (
//               <Avatar
//                 alt="Remy Sharp"
//                 src={objAfter?.file ? file.image : file.image + `?v='${Date.now()}`}
//                 sx={{ width: 80, height: 80 }}
//                 className="image_center"
//               />
//             )}
//             <Button
//               style={{
//                 width: !file ? 80 : null,
//                 height: !file ? 80 : 30,
//                 borderRadius: !file ? 40 : 20,
//                 marginTop: 10,
//                 marginBottom: 10,
//                 fontSize: 12
//               }}
//               variant={file ? 'outlined' : 'outlined'}
//               component="label"
//             >
//               {t('EditProfile.buttons.0')}
//               <input
//                 type="file"
//                 hidden
//                 accept="image/*"
//                 onChange={(e) => {
//                   setobjAfter({
//                     file: true
//                   });
//                   setfile({
//                     image: URL.createObjectURL(e.target.files[0]),
//                     file: e.target.files[0]
//                   });
//                 }}
//               />
//             </Button>
//           </Box>
//         </Stack>
//         <Grid container spacing={2} className="top_column">
//           {user?.role !== 4 && (
//             <>
//               <Grid item lg={6} sm={12} md={12}>
//                 <TextField
//                   id="outlined-error-helper-text"
//                   fullWidth
//                   label={'Name'}
//                   type="text"
//                   value={firstName}
//                   onChange={(val) => {
//                     setfirstName(val.target.value);
//                   }}
//                   variant="outlined"
//                   display="inline"
//                 />
//               </Grid>
//             </>
//           )}

//           <Grid item lg={6} sm={12} md={12}>
//             <TextField
//               id="outlined-error-helper-text"
//               fullWidth
//               label={t('EditProfile.fields.2')}
//               value={email}
//               onChange={(val) => {
//                 setemail(val.target.value);
//               }}
//               type="text"
//               variant="outlined"
//               display="inline"
//             />
//           </Grid>
//           <Grid item lg={12} sm={12} md={12}>
//             <TextField
//               id="outlined-error-helper-text"
//               fullWidth
//               label={t('EditProfile.fields.3')}
//               name="contact"
//               value={contact}
//               onChange={(val) => {
//                 setcontact(val.target.value);
//               }}
//               type="tel"
//               variant="outlined"
//               display="inline"
//             />
//           </Grid>
//         </Grid>
//       </CardContent>

//       {alert && alert.visible && <Alert severity="error">{alert.message}</Alert>}
//       <Box
//         sx={{
//           display: 'flex',
//           justifyContent: 'flex-end',
//           p: 2
//         }}
//       >
//         <LoadingButton
//           disabled={false}
//           loading={loading}
//           sx={{
//             marginRight: 1
//           }}
//           onClick={() => {
//             SaveProfile();
//           }}
//           color="primary"
//           variant="contained"
//         >
//           {t('EditProfile.buttons.1')}
//         </LoadingButton>
//         <LoadingButton
//           sx={{
//             marginRight: 1
//           }}
//           onClick={handleClose}
//           variant="outlined"
//         >
//           {t('EditProfile.buttons.2')}
//         </LoadingButton>
//       </Box>
//     </Box>
//   );
// }

import React, { useState, useEffect } from 'react';
import {
  Box,
  Grid,
  Button,
  CardContent,
  TextField,
  Typography,
  Stack,
  Avatar
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import Alert from '@mui/material/Alert';
import { api } from '../../../Api';
import { useTranslation } from 'react-i18next';
import GooglePlaces from 'src/components/GooglePlaces';

export default function EditUserModal({ handleClose, user, refreshAdmin }) {
  const roleName = user?.role?.role_name;
  const { t } = useTranslation();
  const [loading, setloading] = useState(false);
  const [alert, setalert] = useState({ visible: false, message: '' });
  const [file, setfile] = useState({ image: user?.staff_member?.avatar, file: '' });
  const [firstname, setfirstname] = useState(user?.name);
  const [lastname, setlastname] = useState(user?.name);
  const [about_me, setabout_me] = useState(user?.about_me ? user?.about_me : null);
  const [phone, setPhone] = useState(user?.contact_no ? user?.contact_no : '');
  const [address, setaddress] = useState(null);
  const [email, setemail] = useState('');
  const [error, setError] = useState(false);
  console.log('edit or add', user);

  useEffect(() => {
    if (user) {
      setfirstname(user?.staff_member?.first_name);
      setlastname(user?.staff_member?.last_name);
      setemail(user?.email);
      setPhone(user?.staff_member?.contact_no);
    }

    // if (user && user?.location) {
    //   setaddress({
    //     address: user?.location,
    //     lat: user?.lat || null,
    //     lon: user?.lon || null,
    //     country: user?.country || null,
    //     city: user?.city || null
    //   });
    // }
  }, [user]);

  function SaveProfile() {
    const token = localStorage.getItem('token');

    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdata = new FormData();
    formdata.append('user_id', user?.id);
    formdata.append('first_name', firstname);
    formdata.append('last_name', lastname);
    formdata.append('email', email);
    // about_me && formdata.append('about_me', about_me);
    phone && formdata.append('contact_no', phone);
    // if (address) {
    //   formdata.append('location', address?.address);
    //   formdata.append('country', address?.country);
    //   formdata.append('city', address?.city);
    //   formdata.append('lat', address?.lat);
    //   formdata.append('lon', address?.lon);
    // }

    if (file && file.file) {
      formdata.append('avatar', file.file);
    }

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    setloading(true);

    fetch(api.updateProfile, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const response = JSON.parse(body);
        // console.log('response==', JSON.parse(body));
        if (status === 200 || status === 201) {
          refreshAdmin();
          handleClose();
        } else {
          setalert({ visible: true, message: response.error });
        }
      })
      .catch((error) => console.log('error567', error))
      .finally(() => setloading(false));
  }

  const [objAfter, setobjAfter] = useState({
    name: user?.name,
    file: false
  });
  const exceptThisSymbols = ['e', 'E', '+', '-', '.'];
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleChange = (e) => {
    const value = e.target.value;

    if (value.length <= 50) {
      setemail(value);

      // Validate email format
      setError(value && !emailRegex.test(value));
    }
  };

  return (
    <Box
      p={1}
      mt={2}
      style={{ width: '100%' }}
      sx={{
        bgcolor: '#151921',
        backgroundImage: 'none'
      }}
    >
      <Typography variant="h4" style={{ fontWeight: 'bold', textAlign: 'center' }}>
        {t('EditProfile.name')}
      </Typography>

      <CardContent>
        <Stack
          mb={2}
          direction={{ xs: 'column' }}
          style={{ display: 'flex', flexDirection: 'row' }}
          className="image_center"
        >
          <Box
            style={{
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            {file && (
              <Avatar
                alt="Remy Sharp"
                src={objAfter?.file ? file.image : file.image + `?v='${Date.now()}`}
                sx={{ width: 80, height: 80 }}
                className="image_center"
              />
            )}
            <Button
              style={{
                width: !file ? 80 : null,
                height: !file ? 80 : 30,
                borderRadius: !file ? 40 : 20,
                marginTop: 10,
                marginBottom: 10,
                fontSize: 12
              }}
              disabled={roleName?.toLowerCase() == 'user' ? true : false}
              variant={file ? 'outlined' : 'outlined'}
              component="label"
            >
              {t('EditProfile.buttons.0')}
              <input
                type="file"
                hidden
                accept="image/*"
                onChange={(e) => {
                  setobjAfter({
                    file: true
                  });
                  setfile({
                    image: URL.createObjectURL(e.target.files[0]),
                    file: e.target.files[0]
                  });
                }}
              />
            </Button>
          </Box>
        </Stack>
        <Grid container spacing={2} className="top_column">
          <>
            <Grid item lg={6} sm={12} md={12}>
              <TextField
                disabled={roleName?.toLowerCase() == 'user' ? true : false}
                id="outlined-error-helper-text"
                fullWidth
                label={'First Name'}
                type="text"
                value={firstname}
                onChange={(val) => {
                  if (val.target.value.length <= 20) {
                    setfirstname(val.target.value);
                  }
                }}
                variant="outlined"
                display="inline"
              />
            </Grid>
            <Grid item lg={6} sm={12} md={12}>
              <TextField
                disabled={roleName?.toLowerCase() == 'user' ? true : false}
                id="outlined-error-helper-text"
                fullWidth
                label={'Last Name'}
                type="text"
                value={lastname}
                onChange={(val) => {
                  if (val.target.value.length <= 20) {
                    setlastname(val.target.value);
                  }
                }}
                variant="outlined"
                display="inline"
              />
            </Grid>

            <Grid item lg={6} sm={12} md={12}>
              <TextField
                disabled={roleName?.toLowerCase() == 'user' ? true : false}
                fullWidth
                label={'Email'}
                value={email}
                variant="outlined"
                display="inline"
                onChange={handleChange}
                error={error}
                helperText={error ? 'Invalid email' : ''}
                // onChange={(val) => {
                //   if (val.target.value.length <= 50) {
                //     setemail(val.target.value);
                //   }
                // }}
              />
            </Grid>
            <Grid item lg={6} sm={12} md={12}>
              <TextField
                disabled={roleName?.toLowerCase() == 'user' ? true : false}
                fullWidth
                label={'Contact'}
                type="number"
                value={phone}
                onChange={(val) => {
                  if (val.target.value.length <= 20) {
                    setPhone(val.target.value);
                  }
                }}
                variant="outlined"
                display="inline"
                onKeyDown={(e) => exceptThisSymbols.includes(e.key) && e.preventDefault()}
              />
            </Grid>
          </>
        </Grid>
      </CardContent>

      {alert && alert.visible && <Alert severity="error">{alert.message}</Alert>}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          p: 2
        }}
      >
        <LoadingButton
          disabled={false}
          loading={loading}
          sx={{
            marginRight: 1
          }}
          onClick={() => {
            SaveProfile();
          }}
          color="primary"
          variant="contained"
        >
          {t('EditProfile.buttons.1')}
        </LoadingButton>
        <LoadingButton
          sx={{
            marginRight: 1
          }}
          onClick={handleClose}
          variant="outlined"
        >
          {t('EditProfile.buttons.2')}
        </LoadingButton>
      </Box>
    </Box>
  );
}
